import * as React from 'react';

/**
 * Krok BRAND2 bod 8 — LINIOVE IKONY ZNACKY „NAVES".
 *
 * Manual (`docs/design/brand-naves/ikony/ui/`, str. 12) dodava SEST ikon:
 * Dnešek · Zakázky · Nová · Kalendář · Klienti · Report. Vsechny sedi
 * 1:1 na polozky menu (`lib/nav.ts`), takze nahrazuji ikony z `lucide-react`
 * presne u techto sesti a nikde jinde — zbytek menu (~50 polozek) zustava
 * na `lucide-react`, protoze pro ne znacka ikonu nedodala.
 *
 * PROC JSOU CESTY TADY A NE JAKO `<img src>` Z `public/brand/`:
 * ikona v menu meni barvu podle stavu (`currentColor` — aktivni polozka je
 * olivova / limetkova, manual str. 12) a obrazek nactený jako `<img>` barvu
 * dedit neumi. Soubory znacky jsou proto zdrojem a tady jsou JEN data cesty
 * — `brand2-identita.spec.ts` meri, ze se oba zapisy neerozesly: bere `d`
 * z kazdeho SVG v balicku a porovna s konstantou nize.
 *
 * Rozhrani je zamerne tytez jako u `lucide-react` (`size`, `strokeWidth`),
 * aby shell nemusel rozlisovat, odkud ikona je. Vychozi tah je 2 px podle
 * manualu; shell si ho prebiji na stejnou hodnotu, jakou kresli sousedni
 * ikony, aby sest ikon znacky v jednom seznamu nebylo videt jako tezsich.
 */

/** Cesty 1:1 z `docs/design/brand-naves/ikony/ui/*.svg` (mrizka 24 × 24). */
export const BRAND_ICON_PATHS = {
  dnesek: 'M3 10L12 3L21 10V21H15V14H9V21H3Z',
  zakazky: 'M3 7H21V21H3ZM8 7V3H16V7',
  nova: 'M12 4V20M4 12H20',
  kalendar: 'M3 5H21V21H3ZM3 10H21M7 3V7M17 3V7',
  klienti: 'M8 7C8 2 16 2 16 7C16 12 8 12 8 7ZM4 21V18C4 11 20 11 20 18V21',
  report: 'M5 3H15L20 8V21H5ZM15 3V8H20M8 12H17M8 16H17',
} as const;

export type BrandIconName = keyof typeof BRAND_ICON_PATHS;

interface BrandIconProps {
  readonly size?: number | undefined;
  readonly strokeWidth?: number | undefined;
}

function brandIcon(name: BrandIconName): (props: BrandIconProps) => React.JSX.Element {
  const Icon = ({ size = 24, strokeWidth = 2 }: BrandIconProps): React.JSX.Element => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      // Ikona nikdy nenese vyznam sama — vzdy ji doprovazi popisek polozky
      // (manual str. 12: „význam vždy doplnit popiskem"), takze pro ctecku
      // je to dekorace.
      aria-hidden="true"
      focusable="false"
    >
      <path
        d={BRAND_ICON_PATHS[name]}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  Icon.displayName = `BrandIcon(${name})`;
  return Icon;
}

export const BrandIconDnesek = brandIcon('dnesek');
export const BrandIconZakazky = brandIcon('zakazky');
export const BrandIconNova = brandIcon('nova');
export const BrandIconKalendar = brandIcon('kalendar');
export const BrandIconKlienti = brandIcon('klienti');
export const BrandIconReport = brandIcon('report');
